<router-outlet>
  <div *ngIf="loading$ | async"
       class="module-loading-wrapper"
       [class]="theme || 'default-theme'">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</router-outlet>
